import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class PasswordValidationService {

  constructor(private http: HttpClient) { }

  validatePassword(password: string, confirmPassword: string): Observable<ValidationErrors[]> {
    const url = `${API_URL}account/validatepassword`;

    const result = this
      .http
      .post(url, { Password: password, ConfirmPassword: confirmPassword }, { responseType: 'text' }).pipe(
        map((res) => {
          return null;
        }),
        catchError(exception => {
          console.log(exception);
          if (exception.status === 400) {
            const messages = JSON.parse(exception.error);
            const rules = new Array<ValidationErrors>();
            rules.push({ rules: messages });
            return rules;
          }
        })
      );

    return result;
  }
}
